import { contactForm as brandingContactForm } from "../../siteConfig";
import { contactForm as storeContactForm } from "../../storeSiteConfig";
import { useTemplateType } from "./TemplateContext";

interface ContactFormSectionProps {
  title?: string;
  subtitle?: string;
}

export function ContactFormSection({
  title,
  subtitle,
}: ContactFormSectionProps) {
  const templateType = useTemplateType();
  const contactForm = templateType === "store" ? storeContactForm : brandingContactForm;
  const displayTitle = title || contactForm.title;
  const displaySubtitle = subtitle || contactForm.subtitle;

  return (
    <section className="bg-zap-navy py-14 md:py-16">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8">
          <h2
            className="text-2xl md:text-3xl text-white mb-2"
            style={{ fontWeight: 700 }}
          >
            {displayTitle}
          </h2>
          <p className="text-white/60 text-sm">{displaySubtitle}</p>
        </div>

        <form
          className="space-y-4"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder={contactForm.fields.namePlaceholder}
              className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-zap focus:ring-1 focus:ring-zap"
            />
            <input
              type="tel"
              placeholder={contactForm.fields.phonePlaceholder}
              className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-zap focus:ring-1 focus:ring-zap"
            />
          </div>
          <input
            type="email"
            placeholder={contactForm.fields.emailPlaceholder}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-zap focus:ring-1 focus:ring-zap"
          />
          <textarea
            rows={4}
            placeholder={contactForm.fields.messagePlaceholder}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-zap focus:ring-1 focus:ring-zap resize-none"
          />
          <div className="text-center pt-1">
            <button
              type="submit"
              className="inline-flex items-center justify-center bg-zap text-white px-12 py-3 rounded-lg hover:bg-zap-dark transition-colors text-sm"
              style={{ fontWeight: 500 }}
            >
              {contactForm.submitLabel}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}